import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Lot detail -- `/lots/$lotId`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/lots/$lotId",
	component: lazyRouteComponent(() => import("./$lotId.page")),
})
